var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import Modal from "../Layout/Modal";
import { Translate } from "../I18N";
import { MultiSelect } from "../Forms";


import Icons from "../Templates/components/Icons";

const SUPPORTED_PROPERTIES = ['text', 'number', 'date'];














export const PropertyConfigurationModal = ({
  isOpen,
  onClose,
  onAccept,
  templates,
  currentProperties
}) => {
  const currentValues = currentProperties.reduce((result, config) => {
    const { template, properties } = config;
    const props = properties.map((prop) => `${template}-${prop}`);
    return result.concat(props);
  }, []);

  const [values, setValues] = useState(currentValues);
  const options = templates.map((template) => {var _template$properties, _template$_id2;return {
      label: template.name,
      id: template._id,
      value: template._id,
      options: (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.
      map((prop) => {var _template$_id;return {
          label: prop.label,
          value: `${(_template$_id = template._id) === null || _template$_id === void 0 ? void 0 : _template$_id.toString()}-${prop.name}`,
          type: prop.type,
          icon: { type: 'Icons', _id: Icons[prop.type] }
        };}).
      filter((p) => SUPPORTED_PROPERTIES.includes(p.type)).
      concat([
      {
        label: 'Title',
        value: `${(_template$_id2 = template._id) === null || _template$_id2 === void 0 ? void 0 : _template$_id2.toString()}-title`,
        type: 'text',
        icon: { type: 'Icons', _id: Icons.text }
      }])

    };});

  const handleSubmit = (submitedValues) => {
    const processedValues = submitedValues.reduce((result, value) => {
      const templateName = value.split('-')[0];
      const propertyName = value.split('-')[1];
      const template = templates.find((t) => t._id === templateName);

      if (!template) {
        return result;
      }

      const templateConfig = result.find((c) => c.template === template._id);
      if (templateConfig) {
        templateConfig.properties.push(propertyName);
        return result;
      }

      return result.concat({ template: template._id.toString(), properties: [propertyName] });
    }, []);

    onAccept(processedValues);
  };

  return /*#__PURE__*/(
    _jsx(Modal, { isOpen: isOpen, type: "content", className: "suggestion-acceptance-modal" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add properties"), /*#__PURE__*/
    _jsx("span", {}, void 0, "*"))), /*#__PURE__*/


    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      value: values,
      onChange: setValues,
      options: options,
      optionsToShow: 20,
      showSearch: true })), /*#__PURE__*/


    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "left" }, void 0, "*", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Only text, number and date properties are currently supported")), /*#__PURE__*/

    _jsx("button", { type: "button", className: "btn btn-default cancel-button", onClick: onClose }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")), /*#__PURE__*/

    _jsx("button", {
      type: "button",
      className: "btn confirm-button btn-success",
      onClick: () => handleSubmit(values) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")))));




};